import axios from "axios";
import authHeader from "@/services/auth-header";

class SubtitleService {
    extensions = [".vtt", ".srt", ".smi"];

    normalizeUrlSlashes(url) {
        const parts = url.split("://");

        if (parts.length !== 2) {
            return url;
        }

        const protocol = parts[0];
        const path = parts[1].replace(/\/{2,}/g, "/");

        return `${protocol}://${path}`;
    }

    async request(file, sync = 0) {
        if (!file || typeof file !== "string") {
            return false;
        }

        const baseName = file.replace(/\.[^/.]+$/, "");
        const ext = file.split(".").pop().toLowerCase();

        let subtitleUrl = process.env.VUE_APP_API_URL + `file/smi/${baseName}.${ext}?sync=${sync}`;
        subtitleUrl = this.normalizeUrlSlashes(subtitleUrl);
        try {
            const response = await axios.get(subtitleUrl, {
                headers: {
                    ...authHeader(),
                    "Content-Type": "application/json",
                },
                withCredentials: true,
                responseType: "blob",
            });

            if (response.status !== 200) {
                return false;
            }

            const url = URL.createObjectURL(response.data);

            return {
                url,
                name: `${baseName}.${ext}`,
                ext: `.${ext}`,
            };

        } catch (err) {
            return false;
        }
    }

    async find(file, sync = 0) {
        if (!file || typeof file !== "string") {
            return false;
        }

        const baseName = file.replace(/\.[^/.]+$/, "");

        for (const ext of this.extensions) {
            const result = await this.request(`${baseName}${ext}`, sync);

            if (result) {
                return result;
            }
        }

        return false;
    }

    async get(file, sync = 0) {
        return await this.request(file, sync);
    }
}
export default new SubtitleService();